import script from "./StateDiagram.vue?vue&type=script&setup=true&lang=ts"
export * from "./StateDiagram.vue?vue&type=script&setup=true&lang=ts"

import "./StateDiagram.vue?vue&type=style&index=0&id=2f54b680&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f54b680"]])

export default __exports__